import { Box, Button, Flex, Show, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { INSTITUTION_GET_STARTED } from "@constants/analytics";
import Link from "next/link";
import React from "react";
import { trackEvent } from "utils";

const Hero = () => {
  return (
    <Flex
      maxWidth="1512px"
      w="100%"
      h={{ base: 703, md: 809 }}
      py={{ base: "70px", md: "100px" }}
      pos="relative"
      alignItems="center"
      textAlign={{ base: "center", md: "left" }}
      justify={{ md: "space-between" }}
      flexDir={{ base: "column", md: "row" }}
      bg={"#075A5A"}
      gap={{ x: "144px" }}
    >
      <Box
        zIndex={2}
        flexDir="column"
        gap={{ base: 5, md: 8 }}
        maxW={{ base: 336, lg: 692 }}
        pl={{ base: 0, md: 10 }}
      >
        <Text
          color="#fff"
          fontSize={{ base: 32, md: 64 }}
          pos="relative"
          fontWeight={500}
          lineHeight={{ base: "40px", md: "76.80px" }}
          wordBreak={"break-word"}
        >
          Upgrade your investment strategy with ETH restaking
        </Text>
        <Text
          mt={6}
          color="#fff"
          fontSize={{ base: 20, md: 32 }}
          pos="relative"
          fontWeight={500}
          lineHeight={{ base: "24px", md: "38px" }}
        >
          Securely maximize your gains on EigenLayer
        </Text>
        <Link href="#contact-us">
          <Button mt={6} onClick={() => trackEvent(INSTITUTION_GET_STARTED)}>
            GET STARTED
          </Button>
        </Link>
      </Box>
      <Show below="md">
        <Box pos="absolute" w="100%" h={305} bottom={0}>
          <BaseImage
            src="/assets/institutions/hero/illustration-mobile.svg"
            alt="hero"
            fill
          />
        </Box>
      </Show>
      <Show above="md">
        <Box pos="absolute" right={0}>
          <BaseImage
            src="/assets/institutions/hero/illustration.svg"
            alt="hero"
            width={524}
            height={810}
          />
        </Box>
      </Show>
    </Flex>
  );
};

export default Hero;
